import React from 'react';
import { Link } from 'react-router-dom';
import logo from '../assets/img/logo.png';
const Header = () => {
    return (
        
        <header>
            <div className="header">
                <div className="container">
                    <div className="row">
                        <div className="col-12">
                            <nav className="navbar navbar-expand-md sticky-top">
                                <div className="container-fluid flex-row">
                                    <a className="navbar-brand" href="/"><img src={logo} alt="" className='logom' /></a>
                                    <button className="navbar-toggler" type="button" data-bs-toggle="offcanvas"
                                        data-bs-target="#offcanvasNavbar" aria-controls="offcanvasNavbar">
                                        <span className='barsc'></span>
                                        <span className='barsc'></span>
                                        <span className='barsc'></span>
                                    </button>
                                    <div className="offcanvas offcanvas-end" tabindex="-1" id="offcanvasNavbar"
                                        aria-labelledby="offcanvasNavbarLabel">
                                        <div className="offcanvas-header">
                                            <h5 className="offcanvas-title" id="offcanvasNavbarLabel">Bhavana Singh</h5>
                                            <button type="button" className="btnclose" data-bs-dismiss="offcanvas"
                                                aria-label="Close">X</button>
                                        </div>
                                        <div className="offcanvas-body">
                                            <ul className="navbar-nav me-auto mb-2 mb-lg-0">
                                                <li className="nav-item">
                                                    <a className="nav-link" href="/">Home</a>
                                                </li>
                                                <li className="nav-item">
                                                    <a className="nav-link" href="/about-us">About Us</a>
                                                </li>
                                                <li className="nav-item">
                                                    <a className="nav-link" href="/personality-development-courses">Courses</a>
                                                </li>
                                                <li className="nav-item">
                                                    <a className="nav-link" href="/blog">Blog</a>
                                                </li>
                                                <li className="nav-item">
                                                    <a className="nav-link" href="/contact">Contact Us</a>
                                                </li>
                                            </ul>
                                        </div>
                                    </div>
                                </div>
                            </nav>
                        </div>
                    </div>
                </div>
            </div>
        </header>
    );
};

export default Header;
